import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function MultiSelect({ loyalty_program, formData, setFormData }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggleValue = (value) => {
        setFormData((prev) => {
            const selected = new Set(prev.program_id || []);
            if (selected.has(value)) selected.delete(value);
            else selected.add(value);
            return { ...prev, program_id: Array.from(selected) };
        });
    };

    const selectedItems = loyalty_program.filter((item) =>
        (formData.program_id || []).includes(String(item.program_id))
    );

    return (
        <div className="relative w-full" ref={dropdownRef}>
            <div
                className="flex justify-between ml-2 items-center w-full border rounded-xl px-4 py-2 cursor-pointer bg-white focus:ring-2 focus:ring-[#f4a406]"
                onClick={() => setOpen(!open)}
            >
                <div className="flex flex-wrap gap-1">
                    {selectedItems.length > 0 ? (
                        selectedItems.map((item) => (
                            <span
                                key={item.program_id}
                                className="bg-[#f4a406]/10 text-[#f4a406] text-sm px-2 py-0.5 rounded-full"
                            >
                                {item.program_name}
                            </span>
                        ))
                    ) : (
                        <span className="text-gray-400">Select Program</span>
                    )}
                </div>
                <ChevronDown
                    size={18}
                    className={`transition-transform duration-200 ${open ? "rotate-180" : ""
                        }`}
                />
            </div>

            {open && (
                <div className="absolute z-10 w-full bg-white border rounded-xl mt-1 max-h-48 overflow-y-auto shadow-lg">
                    {loyalty_program.map((item) => (
                        <label
                            key={item.program_id}
                            className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                value={item.program_id}
                                checked={(formData.program_id || []).includes(
                                    String(item.program_id)
                                )}
                                onChange={() => toggleValue(String(item.program_id))}
                                className="w-4 h-4 text-[#f4a406] border-gray-300 rounded focus:ring-[#f4a406]"
                            />
                            <span className="ml-2 text-gray-700">{item.program_name}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
}
